<div class="dialog-content">
    <h2 mat-dialog-title>Inviter un  client</h2>
    <mat-dialog-content>
      <mat-form-field>
        <input matInput placeholder="Email" [(ngModel)]="email" required>
      </mat-form-field>
      
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Annuler</button>
      <button mat-raised-button color="primary" (click)="onSend()">Envoyer</button>
    </mat-dialog-actions>

 
  </div>